// MUI X PRO
import {LicenseInfo} from '@mui/x-license-pro';

const muiKey = '252c985903175b4a25556dc66e4d1564Tz03NzM4NSxFPTE3Mjk4NjA5NTgwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=';
LicenseInfo.setLicenseKey(muiKey);